module.exports = __webpack_public_path__ + "img/settings/Akamai.236440.svg";